<template>
    <div class="container">
      <o-bread-crumb :url="{ name: 'MemberTier' }">
        <template v-slot:pageName>
          Member Tier
        </template>
        <template v-slot:pageDetail>
          {{ page.cardTitle }}
        </template>
      </o-bread-crumb>
      <div class="d-flex justify-content-start col-md-6">
        <o-card :card-title="page.cardTitle" class="custom-table mw-450">
          <o-form @submit.prevent="change()" autocomplete="off">
            <div>
              <o-form-group title="member tier name" name="name" class="text-start mb-4 form-group-modern">
                <span class="text-danger"> *</span>
                <o-input-text name="name" v-model="membertier.name" type="text" :autocomplete="'off'" class="modern-input" placeholder="e.g. Gold" />
                <div v-if="validation.name">
                  <div class="custom-alert modern-alert error-alert mt-2" role="alert">
                    <div class="alert-icon"><i class="fas fa-exclamation-circle"></i></div>
                    <div class="alert-content"><p class="alert-list m-0">{{ validation.name[0] }}</p></div>
                  </div>
                </div>
              </o-form-group>
            </div>
            <div>
              <o-form-group title="transaction value min" name="transaction_value_min" class="text-start mb-4 form-group-modern">
                <span class="text-danger"> *</span>
                <o-input-text name="transaction_value_min" :autocomplete="'off'" v-model="membertier.transaction_value_min" type="text" mask="idr" class="modern-input" placeholder="0" />
                <div v-if="validation.transaction_value_min">
                  <div class="custom-alert modern-alert error-alert mt-2" role="alert">
                    <div class="alert-icon"><i class="fas fa-exclamation-circle"></i></div>
                    <div class="alert-content"><p class="alert-list m-0">{{ validation.transaction_value_min[0] }}</p></div>
                  </div>
                </div>
              </o-form-group>
            </div>
            <div>
              <o-form-group title="transaction value max" name="transaction_value_max" class="text-start mb-4 form-group-modern">
                <span class="text-danger"> *</span>
                <o-input-text name="transaction_value_max" :autocomplete="'off'" v-model="membertier.transaction_value_max" type="text" mask="idr" class="modern-input" placeholder="0" />
                <div v-if="validation.transaction_value_max">
                  <div class="custom-alert modern-alert error-alert mt-2" role="alert">
                    <div class="alert-icon"><i class="fas fa-exclamation-circle"></i></div>
                    <div class="alert-content"><p class="alert-list m-0">{{ validation.transaction_value_max[0] }}</p></div>
                  </div>
                </div>
              </o-form-group>
            </div>
            <div class="d-flex justify-content-center spinner-border text-primary spinner-position form" v-if="page.isLoading"></div>
            <div class="spinner" v-if='page.isLoading'></div>
            <div class="d-flex justify-content-between mt-4">
              <button @click.prevent="$router.push({ name: 'MemberTier' })" class="btn btn-light text-white px-4 fw-medium" type="button" style="background-color: #B9B9B9; border: none;">Cancel</button>
              <o-button :disabled='page.isLoading' type="submit" :variant="'primary'" class="px-4 text-white">
                Save
              </o-button>
            </div>
          </o-form>
        </o-card>
        <div v-if="page.cardTitle == 'Create Member Tier'" class="justify-content-start col-md-6">
          <o-card :card-title="page.customize" class="custom-table mw-450 ml-4">
            <o-form @submit.prevent="generate()" autocomplete="off">
              <o-button :disabled='page.isLoading' type="submit" :variant="'primary'" class="px-4 text-white w-100 mt-2">
                Generate Tiering
              </o-button>
            </o-form>
          </o-card>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { OCard, OForm, OFormGroup, OInputText, OButton, OBreadCrumb } from '@/components/OmnihControl';
  import { reactive, ref, onMounted } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import store from '@/store';
  
  export default {
    name: 'AddMemberTier',
    components: {
      OCard,
      OForm,
      OFormGroup,
      OInputText,
      OButton,
      OBreadCrumb,
    },
    setup() {
      const page = reactive({
        isLoading: false,
        cardTitle: 'Create Member Tier',
        customize: 'Default Tier',
      });
  
      const membertier = reactive({
        id: '',
        name: '',
        transaction_value_min: '',
        transaction_value_max: '',
        corporate_id: '',
      });
  
      const validation = ref([]);
  
      const router = useRouter();
      const route = useRoute();
  
      onMounted(async () => {
        loadBusinessProfile();
        if (route.params.id) {
          loadState(route.params.id);
        }
      });
  
      function loadState(id) {
        store.dispatch('MemberTier/read_single', id).then((data) => {
          membertier.id = data.id;
          membertier.name = data.name;
          membertier.transaction_value_min = priceFormat(data.transaction_value_min);
          membertier.transaction_value_max = priceFormat(data.transaction_value_max);
          page.cardTitle = 'Edit Member Tier';
        });
      }
  
      function loadBusinessProfile() {
        store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
          const filter = {
            corporate_id: businessProfile.corporate_id,
          };
          store.commit('MemberTier/add_filter', { filter });
        });
      }
  
      function change() {
        page.isLoading = true;
  
        store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
          membertier.corporate_id = businessProfile.corporate_id;
  
          const data = { ...membertier };

          data.transaction_value_min = data.transaction_value_min.split('.').join("");
          data.transaction_value_max = data.transaction_value_max.split('.').join("");
  
          if (route.name !== 'MemberTierForm') {
            store.dispatch('MemberTier/update', { data }).then(() => {
              router.push({ name: 'MemberTier' });
            }).catch((err) => {
              try {
                validation.value = JSON.parse(err.response.data.error);
              } catch (e) {
                console.error('Error parsing JSON:', e);
                validation.value = ['An unknown error occurred.'];
              }
            }).finally(() => {
              page.isLoading = false;
            });
          } else {
            store.dispatch('MemberTier/create', { data }).then(() => {
              router.push({ name: 'MemberTier' });
            }).catch((err) => {
              try {
                validation.value = JSON.parse(err.response.data.error);
              } catch (e) {
                console.error('Error parsing JSON:', e);
                validation.value = ['An unknown error occurred.'];
              }
            }).finally(() => {
              page.isLoading = false;
            });
          }
        }).catch((err) => {
          console.error('Error fetching business profile:', err);
          validation.value = ['An unknown error occurred.'];
          page.isLoading = false;
        });
      }

      function generate() {
        page.isLoading = true;

        store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
          const corporate_id = businessProfile.corporate_id;
          const tiers = [
            { name: 'Gold', transaction_value_min: '100000', transaction_value_max: '2000000', corporate_id },
            { name: 'Platinum', transaction_value_min: '2000000', transaction_value_max: '5000000', corporate_id },
            { name: 'Diamond', transaction_value_min: '5000000', transaction_value_max: '10000000', corporate_id },
          ];

          const promises = tiers.map(tier => store.dispatch('MemberTier/create', { data: tier }));

          Promise.all(promises)
            .then(() => {
              router.push({ name: 'MemberTier', query: { newMemberTier: 'true' } });
            })
            .catch((err) => {
              try {
                validation.value = JSON.parse(err.response.data.error);
              } catch (e) {
                console.error('Error parsing JSON:', e);
                validation.value = ['An unknown error occurred.'];
              }
            })
            .finally(() => {
              page.isLoading = false;
            });
        }).catch((err) => {
          console.error('Error fetching business profile:', err);
          validation.value = ['An unknown error occurred.'];
          page.isLoading = false;
        });
      }

      function priceFormat(subtotal) {
            const formated = subtotal.toString().replace(/[^0-9]/g,'').replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1.');
            return formated;
        }
  
      return {
        page,
        membertier,
        validation,
        router,
        change,
        generate,
        priceFormat
      };
    },
  };
  </script>
  
  <style scoped>
  .container {
    overflow-x: auto;
  }
  
  .table th,
  .table td {
    word-wrap: break-word;
    white-space: normal;
  }
  
  .form-group {
    width: 250px;
    text-align: left;
    padding-left: 16px;
  }
  
  .json-viewer pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    cursor: pointer;
    color: black;
  }
  
  .json-viewer span {
    cursor: pointer;
    color: black;
  }
  
  .json-viewer button {
    margin-left: 10px;
    cursor: pointer;
    background: none;
    border: none;
    color: black;
  }

  .mw-450 {
    max-width: 500px;
  }

  .ml-4 {
    margin-left: 1.5rem;
  }

  /* Modern Form Styles */
  .form-group-modern {
      font-weight: 500;
      color: #475569;
  }

  .modern-input {
      border: 1px solid #cbd5e1;
      border-radius: 6px;
      padding: 10px 14px;
      font-size: 14px;
      transition: border-color 0.2s, box-shadow 0.2s;
      width: 100%;
      margin-top: 6px;
  }

  .modern-input:focus {
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      outline: none;
  }

  .btn-save-modern {
      padding: 8px 24px;
      border-radius: 6px;
      font-weight: 600;
      transition: transform 0.1s, box-shadow 0.1s;
  }

  .btn-save-modern:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 8px -1px rgba(59, 130, 246, 0.5);
  }

  /* Modern Alert Styles */
  .modern-alert {
    display: flex;
    align-items: flex-start;
    background-color: #fef2f2;
    border-left: 5px solid #ef4444;
    border-radius: 8px;
    padding: 10px 16px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.05);
    animation: fadeIn 0.3s ease-out;
  }

  .modern-alert .alert-icon {
    flex-shrink: 0;
    margin-right: 12px;
    font-size: 16px;
    color: #ef4444;
  }

  .alert-list {
    margin: 0;
    font-size: 13px;
    color: #b91c1c;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-5px); }
    to { opacity: 1; transform: translateY(0); }
  }
  </style>